var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAssurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9879 14.0098H17.5949C17.3009 14.0098 17.011 14.076 16.7481 14.2031L14.7078 15.1899C14.4449 15.317 14.155 15.3831 13.861 15.3831H12.8192C11.8116 15.3831 10.9947 16.1732 10.9947 17.1478C10.9947 17.1871 11.0217 17.2218 11.0608 17.2326L13.5998 17.9343C14.0553 18.0601 14.543 18.0163 14.9667 17.8113L17.1479 16.7566M10.9947 16.5066L6.40541 15.0973C5.59183 14.8439 4.71238 15.1443 4.20274 15.8497C3.83426 16.3597 3.98429 17.0901 4.52114 17.3997L12.031 21.7305C12.5086 22.0059 13.0722 22.0731 13.5975 21.9173L19.9879 20.022",
    stroke: "#FF76C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.05082V5.45416C17 4.55216 17 4.10115 16.7755 3.80691C16.551 3.51266 16.0434 3.36981 15.0282 3.08411C14.3346 2.88891 13.7231 2.65375 13.2346 2.43906C12.5686 2.14635 12.2356 2 12 2C11.7644 2 11.4314 2.14635 10.7654 2.43906C10.2769 2.65375 9.66547 2.8889 8.97185 3.08411C7.95663 3.36981 7.44901 3.51266 7.22451 3.80691C7 4.10115 7 4.55216 7 5.45416V7.05082C7 10.1447 9.81265 12.0009 11.2189 12.7357C11.5562 12.9119 11.7248 13 12 13C12.2752 13 12.4438 12.9119 12.7811 12.7357C14.1873 12.0009 17 10.1447 17 7.05082Z",
    stroke: "#FF76C8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssurance);
export default __webpack_public_path__ + "static/media/iconAssurance.d967cd992a94ccd5583cf56e756ee2ba.svg";
export { ForwardRef as ReactComponent };